import useMetaTags from '../../hooks/useMetaTags';
import { BenefitSection, AssistanceSection, FAQ } from "../../Data/All_Services_Data/flutterAppDevelopmentCompanyData"
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';

const FlutterAppDevelopmentCompany = () => {
  useMetaTags({
    title:
      "Top Flutter App Development Services Company | Warrgyizmorsch Experts",
    description:
      "Warrgyizmorsch is a leading Flutter app development company delivering high-performance, scalable mobile apps tailored to your business needs. Get a free quote today.",
    keywords:
      "flutter developer, flutter development, flutter app development, flutter app development company, flutter app development agency, flutter app development services, flutter development company, flutter mobile app, flutter mobile application, flutter mobile app development, flutter development services, flutter company, flutter application", });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Flutter App Development Services  Company
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    margin-bottom: 30px;
                }
                .header-section img{
                    height: 400px;
                }
                .header-section p{
                    text-align: left;
                }

                @media only screen and (max-width: 990px) {
                    .header-section{
                        flex-direction: column;
                    }
                    .header-section img{
                        height: 200px;
                    }
                        .header-section p{
                        text-align: center;
                    }
                }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/flutter.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  At Warrgyizmorch, you get more than just Flutter developer, we act as your partners in app innovation. We shine as one of the top Flutter app development company by presenting a powerful blend of experience, expert design, and hardcore engineering solutions to produce advanced digital products. Our programmers make the best use of the Flutter framework to build clean, fast, cross-platform apps that work perfectly on Android and iOS. Selecting Flutter helps businesses save almost 50% on development expenses by using one shared codebase instead of two. Through our Flutter app development services, your apps become quick, responsive, and visually appealing. If you are a start-up taking your first steps or an established brand wanting a digital upgrade, we create apps ready to grow with you. Performance, speed, robust security, and native-like experiences are our core focus with Flutter, solidifying our reputation as a market leader among Flutter development companies.
                </p>
              </div>
            </div>

            <Benefits_section data={BenefitSection} />

            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  )
}

export default FlutterAppDevelopmentCompany